<template>
  <div class="columns is-multiline">
  <modal-document
      v-if="modalDocumentActive"
      :close="activeModalDocument"
      :viewDocument="viewDocument"
    />
    <base-loading v-if="loading" />
    <template v-else>
      <div class="column is-12">
        <div class="box">
          <div class="columns is-multiline">
            <div class="column is-6">
              <h2 class="subtitle">
                Facturas
              </h2>
            </div>
            <!-- Listado de Documentos -->
            <div class="column is-12">
              <div class="columns is-multiline is-mobile">
                <template v-if="availableDocuments && availableDocuments.length === 0">
                  <div class="column is-centered has-text-centered">
                    <img class="imagen_error" src="@/assets/image/warnig-error.png" alt="Sin información">
                    <p class="has-text-centered isEmptyText">
                      Aún No Hay Facturas <br>
                      Para Mostrar
                    </p>
                  </div>
                </template>
                <template v-else>
                  <div class="column is-3-desktop is-4-tablet is-6-mobile" v-for="(item, index) in availableDocuments" :key="index">
                    <div class="has_file">
                      <div class="image_content" @click="activeModalDocument(item.name)">
                        <img
                          class="image_pdf"
                          :src="require('@/assets/icon/' + imgUrl(item.name))"
                          alt="Archivo"
                        >
                        <p class="file_name">{{item.documentName}}</p>
                        <p class="date_name">
                          {{ formatDate(item.created_at, 'DD MMMM YYYY') }}
                        </p>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import mixins from '../../mixins/formats'
import BaseLoading from '../../components/ui/Loading.vue'

export default {
  name: 'Results',
  mixins: [mixins],
  components: {
    ModalDocument: () => import('@/components/services/ModalDocument.vue'),
    BaseLoading
  },
  props: {
    serviceId: {
      type: Number
    },
    getStatus: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      dragAndDropCapable: false,
      loading: false,
      loadingButton: false,
      loadingSend: false,
      modalResultActive: false,
      modalDocumentActive: false,
      modalSendResultActive: false,
      modalDelete: false,
      documentRemove: null,
      viewDocument: null,
      isEmpty: 0,
      uploadType: 'archivo',
      urlDocument: null,
      file: null,
      fileName: null,
      documentName: null,
      availableDocuments: [],
      documentGroup: [],
      FILE_DOCUMENT: 1,
      URL_DOCUMENT: 2,
      finished: 2,
      files: []
    }
  },
  methods: {
    ...mapActions(['getInvoicesByServiceId', 'AddDocumentInvoice', 'changeStatusDocumentFile', 'updateStatusService', 'sendInvoicesService', 'deleteInvoice']),
    manageSelections (documentId) {
      this.changeStatusDocumentFile({ serviceId: this.serviceId, documentId })
      const exist = this.documentGroup.find(el => el === documentId)
      if (!exist) {
        this.documentGroup.push(documentId)
      } else {
        const indexElement = this.documentGroup.indexOf(documentId)
        delete this.documentGroup[indexElement]
      }
    },
    async updateStatusServiceAction () {
      this.loadingSend = true
      const data = {
        serviceId: this.serviceId,
        status: this.finished
      }
      const resp = await this.updateStatusService(data)
      this.loadingSend = false
      return resp
    },
    imgUrl (fileName) {
      const ext = fileName.substr(fileName.lastIndexOf('.') + 1)
      const excel = ['xlsx', 'xls', 'xlsm', 'csv', 'xml']
      const image = ['jpeg', 'jpg', 'png']
      const doc = ['doc', 'docx']

      if (excel.includes(ext)) {
        return 'excel-file.png'
      } else if (image.includes(ext)) {
        return 'image-file.png'
      } else if (doc.includes(ext)) {
        return 'word-file.png'
      } else {
        return 'pdf-file.png'
      }
    },
    activeModalDocument (document = null) {
      if (document) this.viewDocument = document
      this.modalDocumentActive = !this.modalDocumentActive
    }
  },
  beforeMount () {
    console.log(this.serviceId)
    this.loading = true
    this.getInvoicesByServiceId(this.serviceId)
      .then(response => {
        if (response.success) {
          this.availableDocuments = response.results
        }
        this.loading = false
      })
  }
}
</script>

<style lang="scss" scoped>
  .box {
    padding: 2.5rem;
  }
  .has_file {
    display: flex;
  }
  .image_content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-shadow: 0 3px 24px 0 rgba(0, 73, 136, 0.12);
    border: solid 1px #e1e5eb;
    background-color: #ffffff;
    max-width: 136.6px;
    min-width: 100px;
    margin: 0 1rem;
    height: 100%;
    cursor: pointer;
  }
  .image_pdf {
    max-width: 40px;
    padding: 2rem 0;
  }
  .image_content:hover .file_name {
    color: #3273dc;
  }
  .file_name {
    color: #0A0A0A;
    cursor: pointer;
    border-top: solid 1px #ebeded;
    padding: 0.5rem;
    font-size: 14px;
    overflow-wrap: break-word;
    word-wrap: break-word;
    -webkit-hyphens: auto;
    -ms-hyphens: auto;
    -moz-hyphens: auto;
    hyphens: auto;
    max-width: inherit;
    min-width: 136.6px;
  }
  .date_name {
    color: #0A0A0A;
    padding: 0.5rem;
    font-size: 12px;
    width: 100%;
  }
  .file_name a {
    color: #0A0A0A;
  }
  .input {
    font-size: 14px;
  }
  .input_ibs {
    margin: 2rem 0 3rem 0;
  }
  .is-medium {
    width: 196px;
  }
  .input-width {
    width: 300px;
  }

  .file-cta {
    background-color: white;
    color: #4a4a4a;
  }
  .file.is-boxed.has-name .file-cta {
    border-radius: 0px;
    min-width: 300px;
  }
  .file.is-boxed.has-name .file-name {
    border-radius: 0px;
  }
  .image_file_input {
    max-width: 60px;
  }
  .file-label {
    font-size: 16px;
    line-height: 1.54;
    text-align: center;
    color: #404254;
    padding-top: 1rem;
  }
  .is-danger-outlined .file-cta {
    border: 1px solid red;
  }
  .has_file_input {
    font-size: 60px;
    color: var(--primary-green);
  }
  .imagen_error {
    max-width: 80px;
    margin-bottom: 10px;
  }
  .isEmptyText {
    font-size: 14px;
    text-align: center;
    color: '#FAFAFA';
  }
  .delete_icon {
    font-size: 20px;
    cursor: pointer;
  }
</style>
